export const SET_RESULT_DATA = 'SET_RESULT_DATA';
export const SET_IS_LOADING_HEATMAP = 'SET_IS_LOADING_HEATMAP';
export const SET_LOGIN_WORD = 'SET_LOGIN_WORD';